import AuthButtons from '../../../../../pages/tabs/home/components/AuthButtons/AuthButtons';
import { useTranslation } from 'react-i18next';
import PlateIcon from '../../../../../assets/icons/PlateIcon';
import DiscountsIcon from '../../../../../assets/icons/DiscountsIcon';
import { ReactElement } from 'react';
import CupIcon from '../../../../../assets/icons/CupIcon';
import { User } from 'lucide-react';

const NoAuthContent = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Orders:Components:NoAuthContent' });

  return (
    <>
      <div className="my-auto flex h-full flex-col items-center justify-center space-y-md px-md">
        <div className="w-full space-y-3">
          <div className="size-16 rounded-full bg-muted flex items-center justify-center mx-auto">
            <User className="size-8 text-muted-foreground" />
          </div>
          <h4 className="text-center font-semibold">{t('title')}</h4>
          <p className="text-muted-foreground text-center text-sm">{t('subtitle')}</p>
        </div>
        <AuthButtons className="w-full" />
        <Benefits />
      </div>
    </>
  );
};

const BENEFITS_ITEMS: Readonly<{ key: string; icon: ReactElement }[]> = [
  { key: 'earn_points', icon: <CupIcon className="shrink-0 stroke-black" /> },
  { key: 'redeem_points', icon: <PlateIcon className="shrink-0 stroke-black" /> },
  { key: 'get_deals', icon: <DiscountsIcon className="shrink-0 stroke-black" /> },
] as const;

const Benefits = () => {
  const { t } = useTranslation(null, {
    keyPrefix: 'Modules:Mobile:Pages:Tabs:Orders:Components:NoAuthContent.benefits',
  });

  return (
    <div className="flex flex-col gap-sm w-full">
      {BENEFITS_ITEMS.map((item) => (
        <div key={item.key} className="rounded-lg border w-full h-16 p-sm flex gap-sm">
          <div className="flex items-center justify-center">{item.icon}</div>
          <div>
            <p className="text-sm font-medium">{t(`${item.key}.title`)}</p>
            <p className="text-xs text-muted-foreground">{t(`${item.key}.title`)}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NoAuthContent;
